<template>
  <div id="app">
    <router-view/>
    <Pop></Pop>
  </div>
</template>

<script>
  import Pop from 'views/pop'
  export default {
    components: {
      Pop
    }
  }
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  height: 100%;
  .wrap {
    position: relative;
    top: 60px;
    width: 1000px;
    min-width: 1000px;
    margin: 0 auto 60px;
    min-height: calc(100% - 167px);
  }
}
</style>
